// extracted by mini-css-extract-plugin
export var details = "_fw-0";
export var inspectorPopover = "_fw-1";